import React from 'react'

import 'styles/spinner.less'

type SpinnerProps = {
  show: boolean
  header?: string
}

const Spinner = ({ show, header }: SpinnerProps) => {
  if (!show) {
    return null
  }
  let label: JSX.Element | string = ''
  if (header) {
    label = <h1>{header}</h1>
  }
  return (
    <div>
      {label}
      <div className="spinner la-ball-clip-rotate la-dark la-lg">
        <div></div>
      </div>
    </div>
  )
}

export default Spinner
